// components/product/ProductCard.js - Default customer-facing card
export { default } from './CustomerProductCard';